export const ENQUIRY_TYPE_FIELD = 'enquiryType';
export const FIRST_NAME_FIELD = 'firstName';
export const LAST_NAME_FIELD = 'lastName';
export const EMAIL_FIELD = 'email';
export const PHONE_NUMBER_FIELD = 'phoneNumber';
export const PREFERRED_CONTACT_METHOD_FIELD = 'preferredContactMethod';
export const NEAREST_LOCATION_FIELD = 'nearestLocation';
export const INVESTMENT_METHOD_FIELD = 'investmentMethod';
export const INVESTED_BEFORE_FIELD = 'investedBefore';
export const INVESTMENT_AMOUNT_FIELD = 'investmentAmount';
export const MESSAGE_FIELD = 'message';

export const initialFormValues = {
    [ENQUIRY_TYPE_FIELD]: '',
    [FIRST_NAME_FIELD]: '',
    [LAST_NAME_FIELD]: '',
    [EMAIL_FIELD]: '',
    [PHONE_NUMBER_FIELD]: '',
    [PREFERRED_CONTACT_METHOD_FIELD]: '',
    [NEAREST_LOCATION_FIELD]: '',
    [INVESTMENT_METHOD_FIELD]: '',
    [INVESTED_BEFORE_FIELD]: '',
    [INVESTMENT_AMOUNT_FIELD]: '',
    [MESSAGE_FIELD]: '',
};
